export default __webpack_public_path__ + "static/media/news3.c33d9c1e.jpg";